// extracted by mini-css-extract-plugin
export default {"featureContent":"CRVMJZZY8A","wrapper":"WM9fsd9cS8","featureList":"cy6kkvMBkn","backdrop":"sbTM0WDdSm"};